import SettingsIndex from "@/views/settings/Index";

export default [
  {
    path: "/settings",
    name: "Settings",
    component: SettingsIndex,
  },
];